import API from '../../api/crm/activities'

// Fecha local (YYYY-MM-DD) del instante due_at, para agrupar por día en la
// timezone del usuario (el backend devuelve el instante en UTC).
const toLocalDateStr = iso => {
  const d = new Date(iso)
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
  },
}

const getters = {
  getAll: s => s.records,
  getPending: s => s.records.filter(r => r.status === 'pending' && !r.completed_at),
  getByDate: s => date =>
    s.records.filter(r => r.due_at && toLocalDateStr(r.due_at) === date),
  getDatesWithActivities: s => {
    const dates = new Set()
    s.records.forEach(r => {
      if (r.due_at) dates.add(toLocalDateStr(r.due_at))
    })
    return dates
  },
  uiFlags: s => s.uiFlags,
}

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true })
    try {
      const { data } = await API.get(params)
      commit('SET_RECORDS', Array.isArray(data) ? data : [])
    } catch {
      // swallow: UI shows empty state on fetch failure
    } finally {
      commit('SET_UI_FLAG', { isFetching: false })
    }
  },

  async create({ commit }, activityData) {
    commit('SET_UI_FLAG', { isCreating: true })
    try {
      const { data } = await API.create(activityData)
      commit('ADD_RECORD', data)
      return data
    } catch (error) {
      throw error
    } finally {
      commit('SET_UI_FLAG', { isCreating: false })
    }
  },

  async update({ commit }, { id, ...activityData }) {
    commit('SET_UI_FLAG', { isUpdating: true })
    try {
      const { data } = await API.update(id, activityData)
      commit('UPDATE_RECORD', data)
      return data
    } catch (error) {
      throw error
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false })
    }
  },

  async destroy({ commit }, id) {
    try {
      await API.delete(id)
      commit('REMOVE_RECORD', id)
    } catch (error) {
      throw error
    }
  },
}

const mutations = {
  SET_RECORDS: (s, records) => { s.records = records },
  ADD_RECORD: (s, r) => { s.records.push(r) },
  UPDATE_RECORD: (s, r) => {
    const idx = s.records.findIndex(x => x.id === r.id)
    if (idx !== -1) s.records.splice(idx, 1, r)
  },
  REMOVE_RECORD: (s, id) => { s.records = s.records.filter(r => r.id !== id) },
  SET_UI_FLAG: (s, flags) => { s.uiFlags = { ...s.uiFlags, ...flags } },
}

export default { namespaced: true, state, getters, actions, mutations }
